//Constants
import * as ACTIONS from './actionTypes';

//Types
import { FieldDefaults, LMconfig } from './types';
import { Validation } from './types';
import { ActionEditLiveDealerLMInfo, ActionGetDealerLMAPISuccess, ActionPostDealerLMAPI, ActionPostDealerLMAPISuccess } from './actions';

export interface DealerLMState {
    dealerLMInfo?: LMconfig
    liveDealerLMInfo?: LMconfig
    loadingFields?: { [field: string]: boolean },
    fieldDefaults?: FieldDefaults
    validation?: Validation
    
}

const defaultState: DealerLMState = {

};

type GetDealerLMAction = ActionGetDealerLMAPISuccess | ActionEditLiveDealerLMInfo | ActionPostDealerLMAPISuccess | ActionPostDealerLMAPISuccess;

function DealerLMReducer(state: DealerLMState = defaultState, action: GetDealerLMAction): DealerLMState {
    switch (action.type) {
        case ACTIONS.GET_DEALERLM_API_SUCCESS:
            {
                const ogDealerLMInfo = (action as ActionGetDealerLMAPISuccess).lmconfig
                const defaults: FieldDefaults | undefined = (action as ActionGetDealerLMAPISuccess).defaults
                return {
                    ...state,
                    dealerLMInfo: ogDealerLMInfo,
                    liveDealerLMInfo: { ...ogDealerLMInfo },
                    fieldDefaults: defaults
                }
            }
        case ACTIONS.POST_DEALERLM_API_REQUEST:
            {
                const { field } = (action as ActionPostDealerLMAPI)
                return {
                    ...state,
                    loadingFields: { [field]: true }
                }
            }
        case ACTIONS.POST_DEALERLM_API_SUCCESS:
            {
                const ogDealerLMInfo = (action as ActionPostDealerLMAPISuccess).lmConfig
                const ogValidation = (action as ActionPostDealerLMAPISuccess).validation
                return {
                    ...state,
                    dealerLMInfo: ogDealerLMInfo,                    
                    validation: ogValidation,
                    loadingFields: {}
                }
            }
        case ACTIONS.EDIT_LIVE_DEALER_LM_INFO:
            {
                const changedLive = (action as ActionEditLiveDealerLMInfo).dealerLMInfo
                return {
                    ...state,
                    liveDealerLMInfo: state.liveDealerLMInfo && changedLive ? { ...state.liveDealerLMInfo, ...changedLive } : undefined
                }
            }
        
    }
    return {
        ...state
    }
}



export default DealerLMReducer;